/* ═══════════════════════════════════════════════════════════════
   PETE MILLER. Theme interactions
   Unobtrusive, data-attribute driven. Each feature guards on the
   presence of its elements so it runs safely on any page.
   In the Shopify build, the cart section is swapped for the AJAX
   Cart API; the UI contract (drawer, line items) stays identical.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Math.round(n); };

  /* ─── Sticky header shadow ─── */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.style.boxShadow = window.scrollY > 8 ? '0 1px 0 rgba(23,38,59,0.08), 0 10px 30px -22px rgba(23,38,59,0.5)' : 'none'; };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── Mobile nav ─── */
  var mobileNav = $('[data-mobile-nav]');
  var overlay = $('[data-overlay]');
  function openEl(el) { if (el) el.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeAll() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    $$('[data-drawer], [data-search-overlay], [data-sizeguide-modal]').forEach(function (el) { el.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-nav-open],[data-nav-close],[data-cart-open],[data-cart-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-nav-open')) { e.preventDefault(); openEl(mobileNav); }
    else if (t.hasAttribute('data-cart-open')) { e.preventDefault(); openCart(); }
    else { e.preventDefault(); closeAll(); }
  });
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  // close mobile nav when a link is tapped
  if (mobileNav) $$('a', mobileNav).forEach(function (a) { a.addEventListener('click', closeAll); });

  /* ─── Category filter ─── */
  var filterBtns = $$('[data-filter]');
  var cards = $$('.card[data-category]');
  var countEl = $('[data-filter-count]');
  function applyFilter(cat) {
    filterBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-filter') === cat); });
    var shown = 0;
    cards.forEach(function (card) {
      var match = cat === 'all' || card.getAttribute('data-category') === cat;
      card.classList.toggle('is-hidden', !match);
      if (match) { card.classList.add('is-in'); shown++; }
    });
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' style' : ' styles');
  }
  filterBtns.forEach(function (b) { b.addEventListener('click', function () { applyFilter(b.getAttribute('data-filter')); }); });
  $$('[data-filter-link]').forEach(function (a) {
    a.addEventListener('click', function () { applyFilter(a.getAttribute('data-filter-link')); });
  });
  window.PMfilter = applyFilter; // exposed for completeness
  if (countEl && cards.length) countEl.textContent = cards.length + ' styles';

  /* ─── Scroll reveal ───
     The animation is a nicety; the products showing up is not. An observer
     callback only runs once the browser actually composites a frame, so a page
     that loads without rendering (background tab, bfcache restore, landing back
     here from an external redirect like Shop login) can leave every card stuck
     at opacity:0 with a perfectly good grid underneath. Anything still hidden
     after a beat gets shown unconditionally, and we re-check whenever the page
     is restored or becomes visible again. */
  var revealEls = $$('.reveal');   // never .card -- see the note in theme.css
  function revealAll() { revealEls.forEach(function (el) { el.classList.add('is-in'); }); }

  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });

    // Failsafe: never let a card stay invisible just because no frame rendered.
    setTimeout(function () {
      var above = window.innerHeight;
      revealEls.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < above) el.classList.add('is-in');
      });
    }, 1200);
  } else {
    revealAll();
  }

  // bfcache restores and background-tab wake-ups don't re-run page load.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { revealAll(); document.body.style.overflow = ''; }
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      setTimeout(function () {
        var vis = $$('.card:not(.is-hidden)').some(function (c) { return c.classList.contains('is-in'); });
        if (!vis) revealAll();
      }, 300);
    }
  });

  /* ─── Toast ─── */
  var toastWrap = $('[data-toasts]');
  var checkSVG = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
  function toast(title, body) {
    if (!toastWrap) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = checkSVG + '<div><b>' + title + '</b>' + (body ? '<small>' + body + '</small>' : '') + '</div>';
    toastWrap.appendChild(el);
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
    setTimeout(function () { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 450); }, 3200);
  }
  window.PMtoast = toast;

  /* ═══════════ CART (dual-mode: localStorage preview / Shopify AJAX live) ═══════════ */
  var IS_SHOPIFY = typeof window.Shopify !== 'undefined';
  var STORE_KEY = 'pm-cart-v1';
  var drawerBody = $('[data-cart-body]');
  var drawerFoot = $('[data-cart-foot]');
  var cartDots = $$('[data-cart-count]');
  var cartPage = $('[data-cart-page]');

  var cart = [];
  try { cart = JSON.parse(localStorage.getItem(STORE_KEY)) || []; } catch (e) { cart = []; }
  function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(cart)); } catch (e) {} }

  function openCart() { var d = $('[data-drawer]'); if (d) d.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function setCount(n) { cartDots.forEach(function (d) { d.textContent = n; d.classList.toggle('is-visible', n > 0); }); }
  function emptyHTML() { return '<div class="drawer__empty"><span>Empty, for now.</span>Your cart is waiting on your impeccable taste.</div>'; }
  function cents(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  /* Free-shipping progress bar (threshold: $75 U.S.) */
  var FREE_SHIP_CENTS = 7500;
  function updateShipBar(total, count) {
    var bar = $('[data-ship-bar]'); if (!bar) return;
    if (!count) { bar.hidden = true; return; }
    bar.hidden = false;
    var fill = $('[data-ship-fill]'), msg = $('[data-ship-msg]');
    var pct = Math.min(100, Math.round((total / FREE_SHIP_CENTS) * 100));
    if (fill) fill.style.width = pct + '%';
    if (total >= FREE_SHIP_CENTS) {
      bar.classList.add('is-unlocked');
      if (msg) msg.innerHTML = "You've unlocked free U.S. shipping.";
    } else {
      bar.classList.remove('is-unlocked');
      if (msg) msg.innerHTML = "You're <b>" + cents(FREE_SHIP_CENTS - total) + "</b> away from free U.S. shipping.";
    }
  }

  function lineHTML(o) {
    return '<div class="line-item"><div class="line-item__thumb">' + (o.thumb || '') + '</div>' +
      '<div><div class="line-item__name">' + o.name + '</div>' +
      '<div class="line-item__meta">' + (o.meta || '') + '</div>' + o.qty + '</div>' +
      '<div style="text-align:right"><div class="line-item__price">' + o.price + '</div>' + o.remove + '</div></div>';
  }

  /* ---- localStorage backend (static preview) ---- */
  function localRender() {
    setCount(cart.reduce(function (n, i) { return n + i.qty; }, 0));
    renderLocalCartPage();
    if (!drawerBody) return;
    if (!cart.length) { drawerBody.innerHTML = emptyHTML(); if (drawerFoot) drawerFoot.style.display = 'none'; return; }
    if (drawerFoot) drawerFoot.style.display = '';
    drawerBody.innerHTML = cart.map(function (i, idx) {
      return lineHTML({
        thumb: i.art || '', name: i.name,
        meta: i.type + (i.color ? ' · ' + i.color : '') + (i.size ? ' · ' + i.size : ''),
        price: money(i.price * i.qty),
        qty: '<div class="line-item__qty"><button data-qty="-1" data-idx="' + idx + '" aria-label="Decrease">−</button><span>' + i.qty + '</span><button data-qty="1" data-idx="' + idx + '" aria-label="Increase">+</button></div>',
        remove: '<button class="line-item__remove" data-remove="' + idx + '">Remove</button>'
      });
    }).join('');
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.reduce(function (n, i) { return n + i.price * i.qty; }, 0));
  }
  function renderLocalCartPage() {
    if (!cartPage) return;
    if (!cart.length) {
      cartPage.innerHTML = '<div class="page-hero"><div class="container"><span class="eyebrow">Your bag</span><h1>Cart</h1></div></div>' +
        '<section class="section"><div class="container"><div class="cartpage__empty"><p class="cartpage__empty-h">Your cart is empty.</p><p>Nothing in here yet. Your impeccable taste awaits.</p><a class="btn" href="collection.html?cat=all">Shop the collection</a></div></div></section>';
      return;
    }
    var rows = cart.map(function (i, idx) {
      return '<div class="cartline"><div class="cartline__thumb">' + (i.art || '') + '</div>' +
        '<div class="cartline__info"><div class="cartline__name">' + i.name + '</div><div class="cartline__meta">' + i.type + (i.color ? ' · ' + i.color : '') + (i.size ? ' · ' + i.size : '') + '</div>' +
        '<button class="cartline__remove" data-remove="' + idx + '">Remove</button></div>' +
        '<div class="line-item__qty"><button data-qty="-1" data-idx="' + idx + '" aria-label="Decrease">−</button><span>' + i.qty + '</span><button data-qty="1" data-idx="' + idx + '" aria-label="Increase">+</button></div>' +
        '<div class="cartline__price">' + money(i.price * i.qty) + '</div></div>';
    }).join('');
    cartPage.innerHTML = '<div class="page-hero"><div class="container"><nav class="pdp__crumb"><a href="index.html">Shop</a> / Cart</nav><span class="eyebrow">Your bag</span><h1>Cart</h1></div></div>' +
      '<section class="section"><div class="container"><div class="cartpage"><div class="cartpage__lines">' + rows + '</div>' +
      '<aside class="cartpage__summary"><h3>Summary</h3><div class="cartpage__row"><span>Subtotal</span><span>' + money(cart.reduce(function (n, i) { return n + i.price * i.qty; }, 0)) + '</span></div>' +
      '<p class="cartpage__note">Shipping &amp; taxes calculated at checkout.</p>' +
      '<button class="btn btn--block" data-checkout>Checkout</button>' +
      '<a class="link-underline" href="collection.html?cat=all" style="display:inline-block;margin-top:1rem">Continue shopping</a></aside></div></div></section>';
  }
  function localAdd(d) {
    var ex = cart.filter(function (i) { return i.id === d.id && i.color === d.color && i.size === d.size; })[0];
    if (ex) ex.qty += (d.qty || 1);
    else cart.push({ id: d.id, name: d.name, type: d.type, price: d.price, color: d.color, size: d.size, art: d.art, qty: d.qty || 1 });
    save(); localRender();
  }

  /* ---- Shopify AJAX backend (live store) ---- */
  function shopGet() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function shopRender(c) {
    setCount(c.item_count);
    updateShipBar(c.total_price, c.item_count);
    if (!drawerBody) return;
    if (!c.item_count) { drawerBody.innerHTML = emptyHTML(); if (drawerFoot) drawerFoot.style.display = 'none'; return; }
    if (drawerFoot) drawerFoot.style.display = '';
    drawerBody.innerHTML = c.items.map(function (i, idx) {
      var line = idx + 1;
      var thumb = (i.featured_image && i.featured_image.url) ? '<img src="' + i.featured_image.url + '" alt="" style="width:100%;height:100%;object-fit:cover">' : '';
      var vt = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      return lineHTML({
        thumb: thumb, name: i.product_title, meta: vt, price: cents(i.final_line_price),
        qty: '<div class="line-item__qty"><button data-line="' + line + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease">−</button><span>' + i.quantity + '</span><button data-line="' + line + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase">+</button></div>',
        remove: '<button class="line-item__remove" data-line="' + line + '" data-q="0">Remove</button>'
      });
    }).join('');
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = cents(c.total_price);
  }
  function shopAdd(variantId, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json(); }).then(shopGet).then(shopRender);
  }
  function shopChange(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(shopRender);
  }

  function renderCart() { if (IS_SHOPIFY) shopGet().then(shopRender); else localRender(); }

  function addToCart(d) {
    if (IS_SHOPIFY) {
      if (!d.variantId) { toast('Pick your options', 'Choose a size first.'); return; }
      shopAdd(d.variantId, d.qty || 1)
        .then(function () { openCart(); toast(d.name + ' added', 'Your taste is impeccable (and affordable).'); })
        .catch(function () { toast('Could not add that', 'Please try again.'); });
    } else {
      localAdd(d); openCart(); toast(d.name + ' added', 'Your taste is impeccable (and affordable).');
    }
  }

  // delegate add-to-cart from cards (quick-view / PDP call PM.addToCart directly)
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-add]') : null;
    if (!add) return;
    e.preventDefault();
    var card = add.closest('[data-id]') || add;
    var artEl = card.querySelector ? card.querySelector('.card__art') : null;
    addToCart({
      id: card.getAttribute('data-id'),
      name: card.getAttribute('data-name'),
      type: card.getAttribute('data-type'),
      price: parseFloat(card.getAttribute('data-price')) || 0,
      color: card.getAttribute('data-color') || '',
      variantId: add.getAttribute('data-variant-id') || card.getAttribute('data-variant-id'),
      art: artEl ? artEl.innerHTML : ''
    });
  });

  // qty / remove delegation. Shared by the drawer and the cart page (local mode)
  function localLineClick(e) {
    var loc = e.target.closest('[data-idx]');
    var rem = e.target.closest('[data-remove]');
    if (!(loc || rem)) return;
    if (rem) cart.splice(+rem.getAttribute('data-remove'), 1);
    else { var i = cart[+loc.getAttribute('data-idx')]; if (i) { i.qty += +loc.getAttribute('data-qty'); if (i.qty < 1) cart.splice(cart.indexOf(i), 1); } }
    save(); localRender();
  }
  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var shop = e.target.closest('[data-line]');
      if (IS_SHOPIFY && shop) { shopChange(+shop.getAttribute('data-line'), +shop.getAttribute('data-q')); return; }
      if (!IS_SHOPIFY) localLineClick(e);
    });
  }
  if (cartPage && !IS_SHOPIFY) cartPage.addEventListener('click', localLineClick);

  // Checkout (preview): delegated so it covers both the drawer and the cart page.
  // On Shopify the checkout button is a real submit inside a /cart form.
  if (!IS_SHOPIFY) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-checkout]')) { e.preventDefault(); toast('Secure checkout is coming', 'Real payments arrive when we launch on Shopify.'); }
    });
  }

  // Public API for quick-view / search / PDP
  window.PM = { addToCart: addToCart, openCart: openCart, closeCart: closeAll, toast: toast, money: money, isShopify: IS_SHOPIFY };

  /* ─── Newsletter ─── */
  $$('[data-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      if (input && input.value && input.value.indexOf('@') > 0) {
        toast('Welcome to the club', 'You are officially Almost Premium. Check your inbox.');
        input.value = '';
      } else {
        toast('Hmm, that email looks off', 'Mind double-checking it?');
      }
    });
  });

  /* ═══════════ Shopify enhancements (guarded by Liquid-rendered hooks) ═══════════ */

  // Predictive search. Only wired when the theme's search overlay is present
  var predInput = $('[data-predictive-input]');
  if (predInput) {
    var predResults = $('[data-predictive-results]');
    var predMeta = $('[data-predictive-meta]');
    var predOverlay = $('[data-search-overlay]');
    var debounce;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        if (predOverlay) predOverlay.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        setTimeout(function () { predInput.focus(); }, 120);
      } else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeAll(); }
    });
    predInput.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = predInput.value.trim();
      if (!q) { if (predResults) predResults.innerHTML = ''; if (predMeta) predMeta.textContent = ''; return; }
      debounce = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (predMeta) predMeta.textContent = prods.length ? prods.length + ' result' + (prods.length === 1 ? '' : 's') + ' for "' + q + '"' : 'No matches for "' + q + '"';
            if (!predResults) return;
            if (!prods.length) { predResults.innerHTML = '<p class="search-empty">Nothing matched, but everything we make is worth a look.</p>'; return; }
            predResults.innerHTML = '<div class="ps-list">' + prods.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? '<img src="' + p.featured_image.url + '" alt="">' : '';
              var price = typeof p.price === 'string' ? p.price : (p.price != null ? '$' + (p.price / 100).toFixed(2).replace(/\.00$/, '') : '');
              return '<a class="ps-item" href="' + p.url + '"><span class="ps-item__thumb">' + img + '</span><span><span class="ps-item__name">' + p.title + '</span><span class="ps-item__price">' + price + '</span></span></a>';
            }).join('') + '</div>';
          })
          .catch(function () {});
      }, 220);
    });
  }

  // Product image gallery (Shopify PDP)
  var gallery = $('[data-gallery]');
  if (gallery) {
    var galleryMain = $('[data-gallery-main]', gallery);
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !galleryMain) return;
      var full = thumb.getAttribute('data-full');
      if (full) { galleryMain.srcset = full; galleryMain.src = full; if (thumb.querySelector('img')) galleryMain.alt = thumb.querySelector('img').alt; }
      $$('[data-gallery-thumb]', gallery).forEach(function (x) { x.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });

    /* Variant picker: independent Colour / Size controls resolve to one variant.
       The markup renders a chip per option value; here we hold the current
       selection, look up the matching variant, and keep the hidden id input,
       price, main image and add-to-cart button in step. Combinations that don't
       exist are greyed rather than removed, so the range still reads as a whole
       and a shopper can see that (say) Bay simply doesn't come in 2XL. */
    var picker = document.querySelector('[data-variant-picker]');
    var vDataEl = document.querySelector('[data-variant-data]');
    if (picker && vDataEl) {
      var variants = [];
      try { variants = JSON.parse(vDataEl.textContent); } catch (err) { variants = []; }
      var idInput = document.querySelector('[data-variant-id]');
      var addBtn = document.getElementById('pmAddBtn');
      var priceDisp = document.querySelector('[data-price-display]');
      var chosen = [];
      $$('.opt-chip.is-active', picker).forEach(function (c) {
        chosen[+c.getAttribute('data-opt-index')] = c.getAttribute('data-opt-value');
      });

      function matches(v, sel) {
        return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
      }

      // If nothing reports as available the stock data is untrustworthy rather
      // than the product being genuinely dead -- preview contexts and mid-sync
      // states both do this. Greying every chip and disabling the button on that
      // basis would kill a perfectly buyable page, so treat it as "unknown" and
      // let checkout be the authority.
      var stockKnown = variants.some(function (v) { return v.available; });

      function syncPicker() {
        // Grey any value that can't be reached alongside the other choices.
        $$('.opt-chip', picker).forEach(function (c) {
          if (!stockKnown) { c.classList.remove('is-oos'); return; }
          var i = +c.getAttribute('data-opt-index');
          var probe = chosen.slice();
          probe[i] = c.getAttribute('data-opt-value');
          var reachable = variants.some(function (v) { return v.available && matches(v, probe); });
          c.classList.toggle('is-oos', !reachable);
        });

        var v = variants.filter(function (x) { return matches(x, chosen); })[0];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceDisp && v.price) priceDisp.textContent = v.price;
        if (v.image && galleryMain) {
          galleryMain.srcset = v.image; galleryMain.src = v.image;
          $$('[data-gallery-thumb]', gallery).forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-full') === v.image);
          });
        }
        if (addBtn) {
          var buyable = v.available || !stockKnown;
          addBtn.disabled = !buyable;
          addBtn.textContent = buyable ? 'Add to cart' : 'Sold out';
        }
      }

      picker.addEventListener('click', function (e) {
        var chip = e.target.closest('.opt-chip');
        if (!chip) return;
        var i = +chip.getAttribute('data-opt-index');
        chosen[i] = chip.getAttribute('data-opt-value');
        $$('.opt-chip[data-opt-index="' + i + '"]', picker).forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var lbl = document.querySelector('[data-opt-current="' + i + '"]');
        if (lbl) lbl.textContent = chosen[i];
        syncPicker();
      });

      syncPicker();
    }
  }

  // Size-guide modal (Shopify PDP)
  var sgModalEl = $('[data-sizeguide-modal]');

  /* The print providers append a wall of per-size measurements to every
     product description. That data belongs behind the "size guide" link, not
     splitting the product story in half - so move any description table into
     the modal, where it replaces the generic chart (the garment's own numbers
     beat our approximation). If JS never runs the tables simply stay in the
     description, which is just the old layout. */
  var pdpDesc = $('.pdp__desc');
  if (pdpDesc && sgModalEl) {
    var descTables = $$('table', pdpDesc);
    if (descTables.length) {
      var sgBody = $('.sg-modal__body', sgModalEl);
      if (sgBody) {
        sgBody.innerHTML = '';
        descTables.forEach(function (t) {
          var scroller = document.createElement('div');
          scroller.className = 'sg-scroll';
          scroller.appendChild(t);
          sgBody.appendChild(scroller);
        });
        var note = document.createElement('p');
        note.className = 'sg-note';
        note.textContent = 'Measurements in inches, for this exact garment. Between sizes? Size up. Made-to-order pieces can vary by about ½".';
        sgBody.appendChild(note);
      }
    }
  }

  if (sgModalEl) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizeguide-open]')) {
        e.preventDefault();
        sgModalEl.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else if (e.target.closest('[data-sizeguide-close]')) { e.preventDefault(); closeAll(); }
    });
  }

  renderCart();
})();
